import { post } from "./http";
import common from './constants';
let basic = common.interfacePath.serverTestUrl;

export const flashSale = {
  getResourceTypesList: (params) => {
    return post(`/flashSaleBuyer/getResourceTypesList`, params);
  }, 
  listWillStarFlashSalePage: (params) => {
    return post(`/flashSaleBuyer/listWillStarFlashSalePage`, params);
  }, 
  listInProgressFlashSalePage: (params) => {
    return post(`/flashSaleBuyer/listInProgressFlashSalePage`, params);
  },  
  listFinishedFlashSalePage: (params) => {
    return post(`/flashSaleBuyer/listFinishedFlashSalePage`, params);
  }, 
  listMyTradeFlashSalePage: (params) => {
    return post(`/flashSaleBuyer/listMyTradeFlashSalePage`, params);
  },
};

export const falshSaleDetails = {
  getCommodityById: (params) => {
    return post(`${basic}/product/getCommodityById`, params);
  },
  listFlashSaleRecordPage: (params) => {
    return post(`/flashSaleBuyer/listFlashSaleRecordPage`, params);
  }, 
  getFlashSaleBuyerById: (params) => {
    return post(`/flashSaleBuyer/getFlashSaleBuyerById`, params);
  },
}